module.exports = {"version":"0.4.97"}


//////////////////
// WEBPACK FOOTER
// ./src/metadata.json
// module id = 869
// module chunks = 0